import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const ProductionRates = () => {
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSummary();
  }, []);

  const fetchSummary = async () => {
    try {
      const response = await api.get('/analytics/element-summary');
      setSummary(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching summary:', error);
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading production rates...</div>;

  return (
    <div className="production-rates">
      {summary.length === 0 ? (
        <div className="card">
          <p>No production data available yet. Create some production logs to see rates.</p>
        </div>
      ) : (
        summary.map((element, idx) => (
          <div key={idx} className="element-card">
            <h3>{element.element_detail}</h3>
            <p className="category">{element.element_category}</p>
            
            <div className="phases">
              {element.phases.forming.count > 0 && (
                <div className="phase">
                  <strong>Forming:</strong> {element.phases.forming.avg_mh_per_cy} MH/CY 
                  <span className="count"> (avg of {element.phases.forming.count} pours)</span>
                </div>
              )}
              
              {element.phases.pouring.count > 0 && (
                <div className="phase">
                  <strong>Pouring:</strong> {element.phases.pouring.avg_mh_per_cy} MH/CY 
                  <span className="count"> (avg of {element.phases.pouring.count} pours)</span>
                </div>
              )}
              
              {element.phases.stripping.count > 0 && (
                <div className="phase">
                  <strong>Stripping:</strong> {element.phases.stripping.avg_mh_per_cy} MH/CY 
                  <span className="count"> (avg of {element.phases.stripping.count} pours)</span>
                </div>
              )}
              
              {element.phases.punch.count > 0 && (
                <div className="phase">
                  <strong>Punch Out:</strong> {element.phases.punch.avg_mh_per_cy} MH/CY 
                  <span className="count"> (avg of {element.phases.punch.count} pours)</span>
                </div>
              )}
              
              <div className="phase total">
                <strong>Total:</strong> {element.phases.total.avg_mh_per_cy} MH/CY
                <span className="count"> ({element.phases.total.count} total pours)</span>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ProductionRates;